import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService, IdentityClaims } from '@michelin/auth';
import { Alert, AlertService, AlertType } from '@michelin/theme';
import { AppService } from './app.service';
import { AuthenticationWrapperService } from './services/authentication-wrapper.service';

@Component({
  selector: 'mic-root',
  template: '<router-outlet></router-outlet>',
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly appService = inject(AppService);
  private readonly authenticationWrapperService = inject(AuthenticationWrapperService);
  private readonly alertService = inject(AlertService);
  private readonly router = inject(Router);

  isUserLogin: boolean;

  constructor() {
    this.authenticationWrapperService.onLoginRequired$.subscribe(() => {
      sessionStorage.setItem('needRedirectTo', '/');
      sessionStorage.setItem('loggedHBI', 'true');
      this.authService.setupAutomaticSilentRefresh('access_token');
      this.authService.initCodeFlow();
      this.router.navigate(['']);
    });

    // If login success or page refreshed and user is already logged in
    this.authenticationWrapperService.onLoginSuccess$.subscribe(() => {
      const claims: Partial<IdentityClaims> = this.authService.getIdentityClaims();
      if (claims) {
        this.alertService.showAlert({
          type: AlertType.success,
          content: `Welcome ${claims.given_name} ${claims.family_name} !`
        } as Alert);
        if (sessionStorage.getItem('requested_route') !== null) {
          const redirect = sessionStorage.getItem('needRedirectTo');
          sessionStorage.removeItem('needRedirectTo');
          sessionStorage.removeItem('logoutRedirectTo');
          this.router.navigate([redirect]);
        }
      }
    });

    // If logout success
    this.authenticationWrapperService.onLogoutSuccess$.subscribe(() => {
      this.authenticationWrapperService.logout(this.router);
      this.alertService.showAlert({
        type: AlertType.success,
        content: 'You are successfully disconnected!'
      } as Alert);
    });

    // If session expired
    this.authenticationWrapperService.onSessionExpired$.subscribe(() => {
      this.authenticationWrapperService.logout(this.router);
    });
  }

  ngOnInit(): void {
    const loggedHBI = sessionStorage.getItem('loggedHBI');
    if (loggedHBI) {
      this.router.navigate([]);
    } else {
      this.router.navigate(['/login']);
    }
  }
}
